var map = {
	"./ar.json": 9675,
	"./de.json": 532,
	"./en-US.json": 5458,
	"./es.json": 3458,
	"./fr.json": 1822,
	"./hi.json": 8274,
	"./it.json": 5744,
	"./pt.json": 6709,
	"./ru.json": 8809,
	"./zh-CN.json": 7258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5189;